module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n7n9n3n-93e958a5a36c48ebc6e2e0e2289999ae.svg";